module.exports = __webpack_public_path__ + "static/media/main-bird-rest.a4cb213a.mp3";